const abilities = {
	CREATE_USER: "create_user",
	EDIT_USER: "edit_user",
	DELETE_USER: "delete_user",
	VIEW_USER: "view_user",
	LIST_USER: "list_user"
};

export default abilities;
